import React from "react";
import clsx from "clsx";

type SectionTitleProps = {
  title: string;
  highlightRed?: boolean;
  subtitle?: string;
  description?: string | string[];
  align?: "left" | "center" | "right";
};

const renderWithLineBreaks = (text: string) => {
  return text.split("\n").map((line, idx) => (
    <span key={idx}>
      {line}
      {idx !== text.split("\n").length - 1 && <br />}
    </span>
  ));
};

const BannerTitles: React.FC<SectionTitleProps> = ({
  title,
  highlightRed = false,
  subtitle,
  description,
  align = "center",
}) => {
  const alignment = {
    left: "text-left items-start",
    center: "text-center items-center",
    right: "text-right items-end",
  };

  return (
    <div className={clsx("flex flex-col gap-4", alignment[align])}>
      {subtitle && (
        <h4 className="text-xl md:text-2xl lg:text-3xl text-[#1b1b1b] font-semibold tracking-tight">
          {renderWithLineBreaks(subtitle)}
        </h4>
      )}

      <h2
        className={clsx(
          "text-2xl md:text-3xl lg:text-4xl font-semibold tracking-tight",
          highlightRed ? "text-[#d53333]" : "text-[#272d57]"
        )}
      >
        {renderWithLineBreaks(title)}
      </h2>

      {description && (
        <div className="text-base md:text-lg text-[#1b1b1b] max-w-4xl leading-tight">
          {Array.isArray(description) ? (
            description.map((desc, idx) => (
              <p key={idx} className={idx > 0 ? "mt-4" : ""}>
                {renderWithLineBreaks(desc)}
              </p>
            ))
          ) : (
            <p>{renderWithLineBreaks(description)}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default BannerTitles;
